export class PublicationFolder {
  ProcessId: string;
  Description: string;
  Detail: string;
  DateBegin: any;
  DateEnd: any;
  ActionType: string;
}